

import React, { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { Path } from "./routes";
import ProtectedRoute from "../store/ProtectedRoute";


const NotFound = lazy(() => import("../pages/web/404"));
const Home = lazy(() => import("../pages/web/home"));
const About = lazy(() => import("../pages/web/about"));
const ContactUs = lazy(() => import("../pages/web/contact"));
const Carts = lazy(() => import("../pages/web/cart"));
const Checkout = lazy(() => import("../pages/web/checkout"));

const Terms = lazy(() => import("../pages/web/terms"));

const Privacy = lazy(() => import("../pages/web/privacy"));

const Signup = lazy(() => import("../pages/web/signup"));
const Signin = lazy(() => import("../pages/web/signin"));
const BuyingServices = lazy(() => import("../pages/web/home/BuyingServices"));
const SellingServices = lazy(() => import("../pages/web/home/SellingServices"));


const ForgotPassword = lazy(() => import("../pages/web/forgot-password"));
// const ResetPassword = lazy(() => import("../pages/web/reset-password"));

//USER DASHBOARD
const UserDashboard = lazy(() => import("../pages/dashboard"));
const Upgrade = lazy(() => import("../pages/dashboard/upgrade/Upgrade"));
// const UserEarn = lazy(() => import("../pages/User/earn"));
// const UserLearn = lazy(() => import("../pages/User/learn"));
// const UserNft = lazy(() => import("../pages/User/nft"));
// const UserSettings = lazy(() => import("../pages/User/setting"));
// const UserTrade = lazy(() => import("../pages/User/trade"));

//VENDOR DASHBOARD
const VendorLayout = lazy(
  () => import("../components/VendorLayout")
);

const VendorDashboard = lazy(() => import("../pages/dashboard/vendor/dashboard"));
const VendorPayment = lazy(() => import("../pages/dashboard/vendor/payments"));
const VendorCarHistory = lazy(() => import("../pages/dashboard/vendor/car-history"));
const VendorOrdersHistory = lazy(() => import("../pages/dashboard/vendor/orders-history"));
const VendorUserSettings = lazy(() => import("../pages/dashboard/vendor/vendor-settings"));

const RouterConfig = () => {

  return (
    <Suspense
    //fallback={<Loader />}
    >
      <Routes>
        <Route path={Path.Home} element={<Home />} />
        <Route path={Path.About} element={<About />} />
        <Route path={Path.ContactUs} element={<ContactUs />} />
        <Route path={Path.Carts} element={<Carts />} />
        <Route path={Path.Checkout} element={<Checkout />} />
        <Route path={Path.Terms} element={<Terms />} />
        <Route path={Path.Privacy} element={<Privacy />} />

        <Route path={Path.Signup} element={<Signup />} />
        <Route path={Path.Signin} element={<Signin />} />

        <Route path={Path.Buying} element={<BuyingServices />} />
        <Route path={Path.Selling} element={<SellingServices />} />
        <Route path={Path.UserDashboard} element={<UserDashboard />} />
        <Route path={Path.Upgrade} element={<Upgrade />} />

        {/* <Route path={Path.VendorDashboard} element={<VendorDashboard />} />
          <Route path={Path.VendorPayment} element={<VendorPayment />} />
        */}

        {/* 🔐 PROTECTED ROUTES */}
        <Route element={<ProtectedRoute />}>
          <Route path={Path.VendorDashboard} element={<VendorDashboard />} />
          <Route path={Path.VendorPayment} element={<VendorPayment />} />
          <Route path={Path.VendorCarHistory} element={<VendorCarHistory />} />
          <Route path={Path.VendorOrdersHistory} element={<VendorOrdersHistory />} />
          <Route path={Path.VendorUserSettings} element={<VendorUserSettings />} />

        </Route>
        {/* <Route element={<ProtectedRoute />}>
          <Route path="/auth/vendor" element={<VendorLayout />}>
            <Route index element={<Navigate to="dashboard" replace />} />

            <Route path="dashboard" element={<VendorDashboard />} />
            <Route path="payments" element={<VendorPayment />} />
          </Route>
        </Route> */}

        {/* <Route path={Path.UserEarn} element={<UserEarn />} /> */}
        {/* <Route path={Path.UserLearn} element={<UserLearn />} /> */}
        {/* <Route path={Path.UserNft} element={<UserNft />} /> */}
        {/* <Route path={Path.UserSettings} element={<UserSettings />} /> */}
        {/* <Route path={Path.UserTrade} element={<UserTrade />} /> */}

        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  )

}

export default RouterConfig;